"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactIntl = require("react-intl");

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

var _connectAAARefetch = require("../../../decorators/connectAAARefetch");

var _StatusWrapper = require("../../../components/StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _API = require("../../API");

var _reactRedux = require("react-redux");

var _TCombFormWrapper = require("../../../components/TCombFormWrapper");

var _TCombFormWrapper2 = _interopRequireDefault(_TCombFormWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Form = _tcombForm2.default.form.Form;

function getFormSchema() {
    return _tcombForm2.default.struct({
        name: _tcombForm2.default.String,
        version: _tcombForm2.default.String
    });
}
var getSchemaOptions = function getSchemaOptions(versions) {
    return {
        fields: {
            name: {
                label: React.createElement(_reactIntl.FormattedMessage, { id: "reportList.report.name" }),
                error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.report.name.validationError" })),
                attrs: {
                    autoFocus: true
                }
            },
            version: {
                label: "Befund Version",
                error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.new.modal.reportType.title.validationError" })),
                options: versions.map(function (version) {
                    return {
                        value: version,
                        text: version
                    };
                }),
                factory: _tcombForm2.default.form.Select
            }
        }
    };
};
var ReportUpgradeModal = function (_React$Component) {
    _inherits(ReportUpgradeModal, _React$Component);

    function ReportUpgradeModal(props) {
        _classCallCheck(this, ReportUpgradeModal);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportUpgradeModal).call(this, props));

        _this.onHide = function (e) {
            _this.setState({
                currentFormData: null
            });
            _this.props.onClose();
        };
        _this.onFormChange = function (data) {
            _this.setState({
                currentFormData: data
            });
        };
        _this.onFormSubmit = function (e) {
            e.preventDefault();
            var tempRefs = _this.refs;
            var data = tempRefs.form.getValue();
            if (data) {
                _this.props.upgradeReport(_this.props.selectedReport.uid, data.name, data.version);
            }
        };
        _this.state = {
            currentFormData: null
        };
        return _this;
    }

    _createClass(ReportUpgradeModal, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            if (!this.props.selectedReport) {
                return null;
            }
            if (this.props.reports.reportDefinitions) {
                var _ret = function () {
                    var schema = getFormSchema();
                    var definitionTitle = void 0;
                    var definitionVersion = void 0;
                    _this2.props.reports.reportDefinitions.forEach(function (reportDefinition) {
                        if (reportDefinition.uid === _this2.props.selectedReport.definitionUid) {
                            definitionTitle = reportDefinition.title;
                            definitionVersion = reportDefinition.version;
                            return;
                        }
                    });
                    var versions = [];
                    _this2.props.reports.reportDefinitions.map(function (reportDefinition) {
                        if (reportDefinition.title === definitionTitle && reportDefinition.version > definitionVersion) {
                            versions.push(reportDefinition.version);
                        }
                    });
                    var schemaOptions = getSchemaOptions(versions);
                    if (_this2.state.currentFormData === null) {
                        var newState = _this2.state;
                        var _currentFormData = {
                            name: _this2.props.selectedReport.title
                        };
                        newState.currentFormData = _currentFormData;
                        _this2.setState(newState);
                    }
                    return {
                        v: React.createElement(_reactBootstrap.Modal, { show: _this2.props.showModal, onHide: _this2.onHide, enforceFocus: false }, React.createElement(_StatusWrapper2.default, { isLoading: _this2.props.upgradeReportFetch.loading, error: _this2.props.upgradeReportFetch.error, onDismissError: _this2.props.upgradeReportFetch.dismissError }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement("h3", null, "Upgrade Report")), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement("p", null, "Befund: " + _this2.props.selectedReport.title), React.createElement("p", null, "Befund Vorlage: " + definitionTitle), React.createElement("hr", null), React.createElement("p", { style: { "color": "red" } }, "Beim Upgrade gehen die Inhalte der Schritte Abschluss bzw. Freigabe verloren. Der Befund muss danach neu abgeschlossen und freigegeben werden."), React.createElement(_TCombFormWrapper2.default, { onSubmit: _this2.onFormSubmit, ref: "form", type: schema, options: schemaOptions, value: _this2.state.currentFormData, onChange: _this2.onFormChange })), React.createElement(_reactBootstrap.Modal.Footer, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement(_reactBootstrap.ButtonGroup, null, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", onClick: _this2.onFormSubmit }, "Upgrade Report")))))))
                    };
                }();

                if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
            }
            return null;
        }
    }]);

    return ReportUpgradeModal;
}(React.Component);
ReportUpgradeModal = __decorate([(0, _connectAAARefetch.connectAAARefetch)(function (props) {
    return {
        upgradeReportFetch: { value: null },
        upgradeReport: function upgradeReport(uid, name, version) {
            return {
                upgradeReportFetch: Object.assign(_API.client.buildRefetchOptions(_API.API.upgradeReport(uid, name, version)), {
                    then: function then(report) {
                        props.onSuccess(report);
                    }
                })
            };
        }
    };
}), _reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reports: state.reports
    };
})], ReportUpgradeModal);
exports.default = ReportUpgradeModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reports/ReportUpgradeModal.tsx
 ** module id = 1288
 ** module chunks = 0
 **/